// extracted by mini-css-extract-plugin
module.exports = {"title":"cardTitle_title__1CV0S","titleBold":"cardTitle_titleBold__2dn7W","titleSemiBold":"cardTitle_titleSemiBold__2ukAu","titleTag":"cardTitle_titleTag__2OfXb"};